import { render, staticRenderFns } from "./PhysiotherapistSessions.vue?vue&type=template&id=8a6c981a&scoped=true"
import script from "./PhysiotherapistSessions.vue?vue&type=script&lang=ts"
export * from "./PhysiotherapistSessions.vue?vue&type=script&lang=ts"
import style0 from "./PhysiotherapistSessions.vue?vue&type=style&index=0&id=8a6c981a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6c981a",
  null
  
)

export default component.exports